import React from 'react';
import Logo from './pics/Square-White-Logo-with-Cloured-Background.svg';
import Roses from './pics/roses.jpg';
import Daisies from './pics/daisies.jpg';
import Marigolds from './pics/marigolds.jpg';
import Pothos from './pics/pothos.jpg';
import AloeVera from './pics/aloe-vera.jpg';
import FiddleLeafFig from './pics/fiddle-leaf-fig.jpg';
import Cloves from './pics/cloves.jpg';
import Mint from './pics/mint.jpg';
import Thyme from './pics/thyme.jpg';

function HomePage() {
    return(
        <>
            <body id='homeBody'>
                <div className="container">
                    <div id='headerContainer'>
                        <h1 className = "header">Welcome to Potting Around!</h1> 
                        <img src={Logo} alt="logo" height={100} className="headerLogo"/>
                    </div>
                    <h2 className = "header mediaHeader">Buy the best quality plants at Potting Around!</h2>
                    <div className="innerContainer green">
                        <h2 className = "header">Flowers</h2>
                        <img className='plantImage' src={Roses} alt="roses" height={200} width={200} />
                        <img className='plantImage' src={Daisies} alt="daisies" height={200} width={200} />
                        <img className='plantImage' src={Marigolds} alt="marigolds" height={200} width={200} />
                    </div>
                    <div className="innerContainer blueGreen">
                        <h2 className = "header">House Plants</h2>
                        <img className='plantImage' src={Pothos} alt="pothos" height={200} width={200} />
                        <img className='plantImage' src={AloeVera} alt="aloe vera" height={200} width={200} />
                        <img className='plantImage' src={FiddleLeafFig} alt="fiddle leaf fig" height={200} width={200} />
                    </div>
                    <div className="innerContainer blue">
                        <h2 className = "header">Herbs</h2>
                        <img className='plantImage' src={Cloves} alt="cloves" height={200} width={200} />
                        <img className='plantImage' src={Mint} alt="mint" height={200} width={200} />
                        <img className='plantImage' src={Thyme} alt="thyme" height={200} width={200} />
                    </div>
                </div>
            </body>
        </>
    );
}
export default HomePage;